







































import { PropType, defineComponent, ref, watch, computed, getCurrentInstance } from '@vue/composition-api';
import { useLocale } from '../../../hooks/useLocale';
import {
  ReportDataType,
  CommonType
} from './type';
import AIErrorImage from './images/AIError.png';
import { Message, ReportData } from '../../../dataType';
import http from 'common-module/src/util/http';
import LoadingContainer from './components/loading-container.vue';
export default defineComponent({
  components: {
    LoadingContainer
  },
  props: {
    message: {
      type: Object as PropType<Message<ReportData<any>>>,
      required: true
    },
    item: {
      type: Object as PropType<CommonType>,
      required: true
    },
    summaryError: {
      type: Object,
      default: null
    },
    height: {
      type: String,
      default: '60px'
    },
    actionType: {
      type: String,
      default: 'query_summary_data_retry'
    }
  },
  setup(props) {
    const { t } = useLocale();
    const loading = ref(false);
    const instance = getCurrentInstance()?.proxy!;
    const reportData = computed(() => {
      return props.message.content.report.reportData as ReportDataType;
    });
    watch(() => props.item.asyncStatus, (n) => {
      loading.value = !n;
    }, {
      immediate: true
    });
    const queryAgain = async () => {
      const params = {
        id: props.message.content.base.id,
        actionType: props.actionType,
        actionJson: {
          asyncId: props.item.asyncId
        }
      };
      console.log(params, props.item);
      try {
        loading.value = true;
        await http.post('/chat/action', params);
        loading.value = false;
      } catch (e) {
        loading.value = false;
      }
      instance?.$track.send('WebIM_CheckAgain', {
        Intent_Type: props.message.content.base.intentCode,
        Massage_Id: props.message.content.base.id
      }, true);
    };

    const calcHeight = computed(() => {
      return loading.value ? props.height : props.summaryError ? 'auto' : props.height;
    });

    return {
      t,
      AIErrorImage,
      reportData,
      queryAgain,
      loading,
      calcHeight
    };
  }
});
